import {
  CollideHandler,
  ICollision,
} from '../../actions/collisions/ICollision';
import { InvalidEffect } from '../../actions/effects/InvalidEffect';
import { app } from '../../app';
import { CollideEvent, CollideId } from '../../defs/collide';
import {
  despawnBlockEntity,
  moveBlockEntity,
} from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { SharpenerBlockEffect } from './SharpenerBlockEffect';
import { SharpenerBlockEntity } from './SharpenerBlockEntity';

export class SharpenerBlockCollision implements ICollision {
  private readonly scene: GameScene;
  private readonly entity: SharpenerBlockEntity;
  private readonly resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this.resolveTap,
    block: this.resolveBlock,
    attack: this.resolveAttack,
    fall: this.resolveFall,
  };

  constructor(scene: GameScene, entity: SharpenerBlockEntity) {
    this.scene = scene;
    this.entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this.resolvers[event.id]?.call(this, event) ?? false;
  }

  private async resolveTap() {
    await new InvalidEffect(this.entity).execute();
    return false;
  }

  private async resolveBlock(event: CollideEvent) {
    this.attack();
    return true;
  }

  private async resolveAttack(event: CollideEvent) {
    this.attack();
    return true;
  }

  private async resolveFall() {
    return true;
  }

  private async attack() {
    const entity = this.entity;
    const position = entity.c.position.mapPosition;
    const component = entity.c.blockSharpener;
    const view = component.view;
    const map = this.scene.sessionEntity.c.map;
    const newPosition = position.clone();

    // If count is 1 or lower, despawn block, else decrement count
    if (component.count <= 1) {
      app.sound.play('puzzle-candle-destroy');
      despawnBlockEntity(this.scene, this.entity);
      new SharpenerBlockEffect(this.scene, {
        entity: this.entity,
      }).playDieAnimation();
    } else {
      app.sound.play('puzzle-candle-poke');
      // Unset the block entity, decrement the count, and set the block entity back
      // to force the grid to be updated with the new block size
      map.unsetBlockEntity(this.entity);
      component.count -= 1;
      // If block is rightToLeft, move block one position to the right
      if (entity.c.block.props.orientation === 'rightToLeft') {
        newPosition.x += 1;
      }
      if (entity.c.block.props.orientation === 'bottomToTop') {
        newPosition.y += 1;
      }

      moveBlockEntity(this.scene, this.entity, newPosition);

      this.scene?.events.publish({ id: 'poke' });

      new SharpenerBlockEffect(this.scene, {
        entity: this.entity,
      }).playShredAnimation();
      await view.updateView(true);
    }
  }
}
